module.exports = __webpack_public_path__ + "img/4-2.dd2f6a5b.svg";